<template>
  <Content>
    <template #body>
      <Form
        :scheme="scheme"
        :method-fetch-data="methods.fetchData"
        :method-create-data="methods.createData"
        :method-update-data="methods.updateData"
        :method-update-scheme="methods.updateScheme"
        :send-all-form="true"
      />
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Form from "@/components/Form";

import addCollectionsToScheme from "@/utils/addCollectionsToScheme";
import {
  getDocumentId as fetchData,
  postDocuments as createData,
  putDocuments as updateData,
} from "@/api/documents";
import { RegionalDocument } from "@/api/schemes/regionalDocument";
import { FederalDocument } from "@/api/schemes/federalDocument";

const updateScheme = async (scheme) => {
  try {
    scheme = await addCollectionsToScheme(scheme);
  } catch (err) {
    console.log(err);
  }
  return scheme;
};

export default {
  components: {
    Content,
    Form,
  },
  data() {
    return {
      scheme: this.$route.path.includes("regional")
        ? RegionalDocument
        : FederalDocument,
      methods: {
        fetchData,
        createData,
        updateData,
        updateScheme,
      },
    };
  },
};
</script>
